import { z } from 'zod';

export const ZOAuthConfig = z.object({
  access_token: z.string().min(1),
  tenant: z.string().min(1),
});

export type OAuthConfig = z.infer<typeof ZOAuthConfig>;
